<template>
  <div class="drone-page" ref="droneViews">
    <rightButton
      ref="rightButtonRef"
      :currentRoute="routerActiveVal"
      @toggle="rightBtnToggleHandle"
      @close="activeList = []"
    />
    <div class="drone-page-container">
      <router-view />
    </div>
  </div>
</template>

<script>
import rightButton from './components/rightButton/index.vue';

import mixins from './utils/mixins';
import { mapState } from 'vuex';

export default {
  mixins: [mixins],

  components: {
    rightButton
  },
  computed: {
    ...mapState('socket', ['deviceSNMap'])
  },
  watch: {
    deviceList: {
      handler(newVal) {
        if (newVal) {
          this.boxList = newVal;
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      routerActiveVal: '',
      droneIndex: 0,
      recordVisible: false,
      activeList: [0],
      boxList: [] // 无线盒子
    };
  },
  mounted() {
    setTimeout(() => {
      this.setRouterActive();
    }, 100 * 2);
    this.currentBoxSn = '';
    this.snList = [];
  },
  beforeDestroy() {
    sessionStorage.removeItem('drone-sensor-sn');
  },

  methods: {
    setRouterActive() {
      this.routerActiveVal = sessionStorage.getItem('drone-router-active') || 'drone-real-data';
      this.$router.push({
        name: this.routerActiveVal
      });
    },
    rightBtnToggleHandle(val) {
      this.routerActiveVal = val.key;
      sessionStorage.setItem('drone-router-active', this.routerActiveVal);

      this.realTimeData = [];
      let snStr = sessionStorage.getItem('drone-sensor-sn');
      this.snList = JSON.parse(snStr);

      this.$router.push({
        name: this.routerActiveVal,
        query: {
          sn: this.routerActiveVal === 'drone-alarm-data' ? this.snList : 'no-query'
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.drone-page {
  position: relative;
  height: 100%;
  width: 100%;

  &-container {
    height: 100%;
    width: 100%;
    background: var(--mtable-bg-color);
  }
}
</style>
